import { useAuthStore } from '@nuxt-monorepo/base/app/store/auth';

export function $publicApi<T>(request: Parameters<typeof $fetch<T>>[0], opts?: Parameters<typeof $fetch<T>>[1]) {
    const config = useRuntimeConfig();

    return $fetch<T>(`${config?.public.EXTRANET_API_URL}/${request}`, {
        ...opts,
        headers: {
            // @ts-ignore
            ...opts?.headers,
        },
    });
}

export function $privateApi<T>(request: Parameters<typeof $fetch<T>>[0], opts?: Parameters<typeof $fetch<T>>[1]) {
    const config = useRuntimeConfig();

    return $fetch<T>(`${config?.public.EXTRANET_API_URL}/${request}`, {
        ...opts,
        headers: {
            // @ts-ignore
            'L4-API-Token': config?.EXTRANET_API_TOKEN,
            ...opts?.headers,
        },
        onRequestError: (error) => {
            console.error('Private API Request Error:', `${config.public.EXTRANET_API_URL}/${request}`);
            console.error(error);
        },
        onResponseError: (error) => {
            console.error('Private API Response Error:', `${config.public.EXTRANET_API_URL}/${request}`);
            console.error(error);
        },
    });
}
